import { observer } from "mobx-react-lite";
import * as React from "react";
import { ContextMenuItem, Item } from "./types";
import { TreeItem } from "./treeitem";
import * as styles from "./style.module.css";

export interface TreeViewProps {
  items: Item[];
  expandedIds: string[];
  contextMenuItems: (item: Item) => ContextMenuItem[];
  onItemClick: (item: Item) => void;
  onToggleExpanstion: (item: Item, isExpanded: boolean) => void;
  onContextMenu: (item: Item, contextMenuItem: ContextMenuItem) => void;
  onRenameItem: (item: Item, newName: string) => void;
}

export const TreeView = observer((props: TreeViewProps) => {
  const {
    items,
    expandedIds,
    contextMenuItems,
    onItemClick,
    onToggleExpanstion,
    onContextMenu,
    onRenameItem,
  } = props;

  const onToggle = (item: Item) => {
    const expanded = expandedIds.some((_) => _ == item.id);
    onToggleExpanstion(item, !expanded);
  };

  return (
    <div className={styles.treeView}>
      {items.map((_, i) => (
        <TreeItem
          key={i}
          item={_}
          contextMenuItems={contextMenuItems}
          expandedIds={expandedIds}
          onItemClick={onItemClick}
          onToggleExpanstion={onToggle}
          onContextMenu={onContextMenu}
          onRenameItem={onRenameItem}
        />
      ))}
    </div>
  );
});
